import { action } from 'mobx';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import StocklistReportForm from 'stores/Forms/Reports/StocklistReportForm';
import StocklistReportStore from 'stores/Report/StocklistReportStore';

import Button from 'components/Button/Button';
import Datepicker from 'components/Form/Fields/Datepicker/Datepicker';
import { bindFormControl } from 'components/Form/FormControl/FormControl';
import ActionSelect, {
  ActionSelectOption,
} from 'components/ActionSelect/ActionSelect';

import style from './StocklistReport.module.scss';

interface Props {
  form: StocklistReportForm;
  store: StocklistReportStore;
}

@observer
class StocklistForm extends Component<Props> {
  private _formControl = bindFormControl(this.props.form);
  private _exportOptions: ActionSelectOption[] = [
    {
      title: 'title.pdf',
      action: () =>
        this.props.store.getPdfReport(this.props.form.requestParams),
    },
    {
      title: 'title.csv',
      action: () =>
        this.props.store.getCsvReport(this.props.form.requestParams),
    },
  ];

  @action.bound
  async getReport() {
    const form = this.props.form;

    if (form.isFormValid) {
      await this.props.store.getReport(form.requestParams);
    }
  }

  render() {
    const { form } = this.props;
    const FormControl = this._formControl;

    return (
      <form className={style.form}>
        <div className={style.form__field}>
          <label className={style.form__label}>
            <FormattedMessage id="title.period" />
          </label>

          <FormControl
            name="period"
            render={props => (
              <Datepicker
                {...props}
                styles={{
                  calendar: style.datepicker,
                  button: style.datepicker__btn,
                }}
                value={form.period}
                selectRange
              />
            )}
          />
        </div>

        <Button
          className={style.button}
          onClick={this.getReport}
          disabled={!form.isFormValid}
        >
          <FormattedMessage id="button.generate.report" />
        </Button>

        <ActionSelect
          title="title.export.report"
          options={this._exportOptions}
          styles={{ buttonStyle: style.actionButton }}
        />
      </form>
    );
  }
}

export default StocklistForm;
